/**
 * Premium PDP buy flow: reveal shipping after Box Size selection,
 * unlock ATC after shipping is chosen. Keeps size editable.
 */
(function () {
  'use strict';

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function isBoxSizeInput(el) {
    if (!el || el.type !== 'radio') return false;
    var name = (el.name || '').toLowerCase();
    return name.indexOf('box size') !== -1 || name === 'box size';
  }

  function getShippingSelect(root) {
    return qs(root, '[data-ks-shipping-select]');
  }

  function setShippingEnabled(root, enabled) {
    var select = getShippingSelect(root);
    if (!select) return;
    select.disabled = !enabled;
    if (enabled) {
      select.setAttribute('required', 'required');
    } else {
      select.removeAttribute('required');
    }
  }

  function revealShipping(root) {
    var wrap = qs(root, '[data-ks-premium-shipping-wrap]');
    if (!wrap) return;

    if (wrap.classList.contains('is-visible')) {
      setShippingEnabled(root, true);
      return;
    }

    wrap.removeAttribute('hidden');
    wrap.setAttribute('aria-hidden', 'false');
    setShippingEnabled(root, true);

    // Double rAF so the browser applies the collapsed state before expanding
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        wrap.classList.add('is-visible');
      });
    });
  }

  function updateAtc(root) {
    var atc = qs(root, '[data-ks-premium-atc]');
    if (!atc) return;

    var progressive = root.getAttribute('data-ks-progressive') === 'true';
    var soldOut = atc.getAttribute('data-to-cart-available') !== 'true';
    if (soldOut) {
      atc.disabled = true;
      atc.setAttribute('aria-disabled', 'true');
      atc.setAttribute('data-ks-premium-atc-locked', '');
      return;
    }

    if (!progressive) {
      atc.disabled = false;
      atc.removeAttribute('aria-disabled');
      atc.removeAttribute('data-ks-premium-atc-locked');
      return;
    }

    var sizeReady = root.getAttribute('data-ks-size-ready') === 'true';
    var select = getShippingSelect(root);
    var shippingReady = !select || (select.value && select.value.length > 0);

    if (sizeReady && shippingReady) {
      atc.disabled = false;
      atc.removeAttribute('aria-disabled');
      atc.removeAttribute('data-ks-premium-atc-locked');
    } else {
      atc.disabled = true;
      atc.setAttribute('aria-disabled', 'true');
      atc.setAttribute('data-ks-premium-atc-locked', '');
    }
  }

  function markSizeReady(root) {
    root.setAttribute('data-ks-size-ready', 'true');
    revealShipping(root);
    updateAtc(root);
  }

  function onSizeInteraction(root, target) {
    if (!target) return;
    var input = target;
    if (input.tagName !== 'INPUT') {
      var label = target.closest && target.closest('label[for]');
      if (label) {
        input = document.getElementById(label.getAttribute('for'));
      }
    }
    if (!isBoxSizeInput(input)) return;
    if (input.disabled) return;
    markSizeReady(root);
  }

  function clearBoxSizeSelection(root) {
    qsa(root, 'input[type="radio"]').forEach(function (input) {
      if (!isBoxSizeInput(input)) return;
      input.checked = false;
    });
  }

  function initRoot(root) {
    if (root.getAttribute('data-ks-premium-init') === '1') return;
    root.setAttribute('data-ks-premium-init', '1');

    var progressive = root.getAttribute('data-ks-progressive') === 'true';
    if (!progressive) {
      setShippingEnabled(root, true);
      updateAtc(root);
      return;
    }

    root.setAttribute('data-ks-size-ready', 'false');
    clearBoxSizeSelection(root);
    setShippingEnabled(root, false);
    updateAtc(root);

    // variant-radios may re-check from URL/JSON shortly after load
    window.setTimeout(function () {
      if (root.getAttribute('data-ks-size-ready') === 'true') return;
      clearBoxSizeSelection(root);
    }, 0);
    window.setTimeout(function () {
      if (root.getAttribute('data-ks-size-ready') === 'true') return;
      clearBoxSizeSelection(root);
    }, 250);

    root.addEventListener('change', function (event) {
      var t = event.target;
      if (isBoxSizeInput(t)) {
        markSizeReady(root);
        return;
      }
      if (t && t.matches && t.matches('[data-ks-shipping-select]')) {
        updateAtc(root);
      }
    });

    root.addEventListener('click', function (event) {
      onSizeInteraction(root, event.target);
    });

    var form = qs(root, 'form[data-type="add-to-cart-form"]');
    if (form) {
      form.addEventListener(
        'submit',
        function (event) {
          if (form.getAttribute('data-ks-purchase-confirmed') === '1') return;
          if (root.getAttribute('data-ks-size-ready') !== 'true') {
            event.preventDefault();
            event.stopPropagation();
            var sizeStep = qs(root, '[data-ks-premium-size-step]');
            if (sizeStep && sizeStep.scrollIntoView) {
              sizeStep.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            return;
          }
          var select = getShippingSelect(root);
          if (select && !select.value) {
            event.preventDefault();
            event.stopPropagation();
            revealShipping(root);
            if (window.KSShippingOption && typeof window.KSShippingOption.validate === 'function') {
              window.KSShippingOption.validate(form);
            } else {
              select.focus();
            }
          }
        },
        true
      );
    }
  }

  function initAll() {
    qsa(document, '[data-ks-premium-buy-flow]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
